import { configureStore } from "@reduxjs/toolkit";
import { OutputValue } from "../../../components/common/FlowBots/Outputs/types/types";

const initialState: OutputValue[] = [];

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "ADD_OUTPUT":
      return [...state, action.output];
    case "RESET":
      return initialState;
    case "DELETE":
      return state.filter((_, index) => index !== action.index);
    case "EDIT":
      return state.map((output, index) => (index === action.index ? action.output : output));
    default:
      return state;
  }
};

const store = configureStore({ reducer });

export default store;
